/** Do not edit this file, it is automatically generated **/
import React, { PropsWithChildren } from "react";
import styled from "styled-components";

import Icon, { IconProps } from "./Icon";

const IconUserCircledLineComponent: React.FC<PropsWithChildren<IconProps>> & { DataUrl: string; Content: string; } = (props) => {
return (
  <Icon {...props} viewBox="0 0 32 32">
    <g id="Layer_2" data-name="Layer 2">
    <path d="m16 17a6 6 0 1 1 6-6 6 6 0 0 1 -6 6zm0-10a4 4 0 1 0 4 4 4 4 0 0 0 -4-4z" />
    <path d="m16 31a15 15 0 0 1 -11.59-5.49l-.52-.64.52-.63a15 15 0 0 1 23.18 0l.52.63-.52.64a15 15 0 0 1 -11.59 5.49zm-9.49-6.12a13 13 0 0 0 19 0 13 13 0 0 0 -19 0z" />
    <path d="m16 31a15 15 0 1 1 11.59-5.49 15 15 0 0 1 -11.59 5.49zm0-28a13 13 0 1 0 13 13 13 13 0 0 0 -13-13z" />
    <path d="m5.18 24.88s10.07 11.25 20.32 1.12l1.32-1.12s-8.56-8.88-17.25-3.55z" />
    <circle cx="16" cy="11" r="5" />
</g>
  </Icon>
);
};

IconUserCircledLineComponent.DataUrl = "data:image/svg+xml;charset=utf-8;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzIgMzIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+CiAgICA8cGF0aCBkPSJtMTYgMTdhNiA2IDAgMSAxIDYtNiA2IDYgMCAwIDEgLTYgNnptMC0xMGE0IDQgMCAxIDAgNCA0IDQgNCAwIDAgMCAtNC00eiIvPgogICAgPHBhdGggZD0ibTE2IDMxYTE1IDE1IDAgMCAxIC0xMS41OS01LjQ5bC0uNTItLjY0LjUyLS42M2ExNSAxNSAwIDAgMSAyMy4xOCAwbC41Mi42My0uNTIuNjRhMTUgMTUgMCAwIDEgLTExLjU5IDUuNDl6bS05LjQ5LTYuMTJhMTMgMTMgMCAwIDAgMTkgMCAxMyAxMyAwIDAgMCAtMTkgMHoiLz4KICAgIDxwYXRoIGQ9Im0xNiAzMWExNSAxNSAwIDEgMSAxMS41OS01LjQ5IDE1IDE1IDAgMCAxIC0xMS41OSA1LjQ5em0wLTI4YTEzIDEzIDAgMSAwIDEzIDEzIDEzIDEzIDAgMCAwIC0xMy0xM3oiLz4KICAgIDxwYXRoIGQ9Im01LjE4IDI0Ljg4czEwLjA3IDExLjI1IDIwLjMyIDEuMTJsMS4zMi0xLjEycy04LjU2LTguODgtMTcuMjUtMy41NXoiLz4KICAgIDxjaXJjbGUgY3g9IjE2IiBjeT0iMTEiIHI9IjUiLz4KICA8L2c+Cjwvc3ZnPg==";
IconUserCircledLineComponent.Content = `<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
  <g id="Layer_2" data-name="Layer 2">
    <path d="m16 17a6 6 0 1 1 6-6 6 6 0 0 1 -6 6zm0-10a4 4 0 1 0 4 4 4 4 0 0 0 -4-4z"/>
    <path d="m16 31a15 15 0 0 1 -11.59-5.49l-.52-.64.52-.63a15 15 0 0 1 23.18 0l.52.63-.52.64a15 15 0 0 1 -11.59 5.49zm-9.49-6.12a13 13 0 0 0 19 0 13 13 0 0 0 -19 0z"/>
    <path d="m16 31a15 15 0 1 1 11.59-5.49 15 15 0 0 1 -11.59 5.49zm0-28a13 13 0 1 0 13 13 13 13 0 0 0 -13-13z"/>
    <path d="m5.18 24.88s10.07 11.25 20.32 1.12l1.32-1.12s-8.56-8.88-17.25-3.55z"/>
    <circle cx="16" cy="11" r="5"/>
  </g>
</svg>`;

const IconUserCircledLine = styled(IconUserCircledLineComponent)``;

export default IconUserCircledLine;
